import { BaseInput as r } from "./index.es62.js";
import { PasswordInput as o } from "./index.es63.js";
import { WithButton as t } from "./index.es64.js";
import { Search as m } from "./index.es65.js";
import { Twice as i } from "./index.es66.js";
import { WithSelect as p } from "./index.es67.js";
import { NumericInput as e } from "./index.es68.js";
import { Textarea as f } from "./index.es69.js";
import { WithText as a } from "./index.es70.js";
import { MoneyInput as n } from "./index.es71.js";
import { Variable as s } from "./index.es72.js";
import { History as u } from "./index.es73.js";
var N = {
  Base: r,
  Password: o,
  WithButton: t,
  Search: m,
  Twice: i,
  WithSelect: p,
  Numeric: e,
  Textarea: f,
  WithText: a,
  History: u,
  Money: n,
  Variable: s
};
export { N as Input };